import React from "react";

export function Field({ label, value, badge }: { label: string; value: React.ReactNode, badge?: React.ReactNode }) {
    const hasValue = value !== null && value !== undefined && value !== "" && value !== "—";

    return (
        <div className="space-y-1">
            <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}{badge}</dt>
            <dd
                className={` ${
                    hasValue ? "field-value" : "field-value empty"
                }`}
                >
                {hasValue ? value : "N/A"}
            </dd>
        </div>
    );
}

export function InputField({
    label,
    children,
    error,
}: {
    label: string;
    children: React.ReactNode;
    error?: string;
}) {
    return (
        <div className="space-y-1.5">
            <label className="block text-xs font-medium uppercase tracking-wide text-muted-foreground">
                {label}
            </label>
            {children}
            {error && (
                <p className="text-xs font-medium text-red-600">{error}</p>
            )}
        </div>
    );
}

export function TextInput({
    hasError = false,
    ...props
}: React.InputHTMLAttributes<HTMLInputElement> & { hasError?: boolean }) {
    return (
        <input
            {...props}
            className={`w-full rounded-lg border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 ${hasError
                    ? "border-red-300 focus:border-red-500 focus:ring-red-500/20"
                    : "border-border focus:border-[#21506F] focus:ring-[#21506F]/20"
                } ${props.className ?? ""}`}
        />
    );
}

export function TextArea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
    return (
        <textarea
            {...props}
            className={`w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:border-[#21506F] focus:outline-none focus:ring-2 focus:ring-[#21506F]/20 ${props.className ?? ""}`}
        />
    );
}

export function SelectInput(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
    return (
        <select
            {...props}
            className={`w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground focus:border-[#21506F] focus:outline-none focus:ring-2 focus:ring-[#21506F]/20 ${props.className ?? ""}`}
        />
    );
}

export function SummaryChip({
    label,
    value,
}: {
    label: string;
    value: React.ReactNode;
}) {
    return (
        <div className="inline-flex items-center gap-2 rounded-full border border-border bg-muted/60 px-3 py-1.5 text-sm">
            <span className="font-medium text-muted-foreground">{label}:</span>
            <span className="font-semibold text-foreground">{value ?? "—"}</span>
        </div>
    );
}

export function safeText(v: unknown): string {
    if (v === null || v === undefined) return "—";
    if (typeof v === "string" && v.trim() === "") return "—";
    return String(v);
}